import React from 'react';
import { Helmet } from 'react-helmet-async';
import './not-found.css';

const NotFound = () => {
  return (
    <div className="not-found-container">
      <Helmet>
        <title>404 - Página No Encontrada | Matias Cagliero</title>
        <meta name="description" content="Lo sentimos, la página que buscas no existe en el portafolio de Matias Cagliero." />
        <meta name="robots" content="noindex, follow" />
        <meta property="og:title" content="404 - Página No Encontrada" />
        <meta property="og:description" content="Oops! Parece que este link no lleva a ninguna parte." />
      </Helmet>

      <div className="not-found-block">
        <h1 className="not-found-title">404</h1>

        <div className="not-found-divider" />

        <p className="not-found-message">Página no encontrada</p>
        <p className="not-found-subtext">
          Es posible que hayas escrito mal la dirección o que la página haya sido eliminada.
        </p>

        <a href="/" className="not-found-back">← Volver al inicio</a>
      </div>
    </div>
  );
};

export default NotFound;
